import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-file',
  templateUrl: './video-file.component.html',
  styleUrls: ['./video-file.component.scss']
})
export class VideoFileComponent implements OnInit {

  @Input()
  fileUrl: string;

  ngOnInit(): void {
  }

}
